import React, { FC, PropsWithChildren } from 'react';

type IDotLoadingProps = PropsWithChildren<{
  loading?: boolean;
}>;

const DotLoading: FC<IDotLoadingProps> = ({ loading, children }) => {
  if (loading) return <>...</>;
  return <>{children}</>;
};

export default DotLoading;
